function hexToRGB(hex) {
    // Check if input is valid hex color
    if (!/^#([0-9A-Fa-f]{3}){1,2}$/.test(hex)) {
        throw new Error("Invalid hex color format")
    }

    // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
    const expandedHex =
        hex.length === 4
            ? "#" + hex[1] + hex[1] + hex[2] + hex[2] + hex[3] + hex[3]
            : hex
    const r = parseInt(expandedHex.substring(1, 3), 16)
    const g = parseInt(expandedHex.substring(3, 5), 16)
    const b = parseInt(expandedHex.substring(5, 7), 16)

    return [r, g, b]
}

export { hexToRGB }
